import PolicyPage from "./PolicyPage";

export default function TermsAndConditions() {
    return <PolicyPage name="terms" />;
}
